<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
        <h6 class="proxima-nova-bold mb-3">Google Ads Jobs</h6>
        <table class="client1-table table-format set_column_width table table-striped table-bordered dt-responsive nowrap" v-bind:id=id style="width:100% !important">
            <thead>
            <tr>
                <th>Job ID</th>
                <th>Invoice</th>
                <th>Domain</th>
                <th>Action</th>
                <th>Status</th>
                <th>Message</th>
                <th>Ran At</th>
                <th>Created At</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="(task, idx) in tasks">
                <td>
                    {{ task.id }}
                </td>
                <td>
                    {{ task.invoice_draft_id }}
                </td>
                <td>
                    <a :href="'/googleads/domain/' + domain.id"
                       target="_blank">{{ domain.name | decodeURI }}</a>
                </td>
                <td>
                    {{ task.action }}
                </td>
                <td>
                    {{ task.status }}
                </td>
                <td>
                    {{ task.message }}
                </td>
                <td>
                    <span v-if="task.ran_at">
                        {{ task.ran_at | formatDate }}
                    </span>
                </td>
                <td>
                    {{ task.created_at | formatDate }}
                </td>
            </tr>

            </tbody>
        </table>
    </div>
</template>

<script>


import moment from "moment";
import punycode from "punycode";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import 'datatables.net-responsive-dt'

export default {
    props: ['tasks', 'domain','id'],
    data: function () {
        return {};
    },
    mounted() {
        if (!$.fn.DataTable.isDataTable('#goo-add-job-dt-table') )
        {
            $('#goo-add-job-dt-table').DataTable({responsive: true});
        }

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
    filters: {
        decodeURI(URI){
            return punycode.toUnicode(URI);
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD HH:mm');
        }
    }
}
</script>

<style scoped>

</style>
